module.exports = __webpack_public_path__ + "09_mustache_brown.d6968331.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/09_mustache_brown.png
// module id = Wrql
// module chunks = 0